"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckPackageDto = instanceOfBackgroundCheckPackageDto;
exports.BackgroundCheckPackageDtoFromJSON = BackgroundCheckPackageDtoFromJSON;
exports.BackgroundCheckPackageDtoFromJSONTyped = BackgroundCheckPackageDtoFromJSONTyped;
exports.BackgroundCheckPackageDtoToJSON = BackgroundCheckPackageDtoToJSON;
exports.BackgroundCheckPackageDtoToJSONTyped = BackgroundCheckPackageDtoToJSONTyped;
const BackgroundCheckProvider_1 = require("./BackgroundCheckProvider");
/**
 * Check if a given object implements the BackgroundCheckPackageDto interface.
 */
function instanceOfBackgroundCheckPackageDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('externalPackageKey' in value) || value['externalPackageKey'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('deletedAt' in value) || value['deletedAt'] === undefined)
        return false;
    return true;
}
function BackgroundCheckPackageDtoFromJSON(json) {
    return BackgroundCheckPackageDtoFromJSONTyped(json, false);
}
function BackgroundCheckPackageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderFromJSON)(json['provider']),
        'externalPackageKey': json['externalPackageKey'],
        'name': json['name'],
        'deletedAt': (json['deletedAt'] == null ? null : new Date(json['deletedAt'])),
    };
}
function BackgroundCheckPackageDtoToJSON(json) {
    return BackgroundCheckPackageDtoToJSONTyped(json, false);
}
function BackgroundCheckPackageDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderToJSON)(value['provider']),
        'externalPackageKey': value['externalPackageKey'],
        'name': value['name'],
        'deletedAt': (value['deletedAt'] == null ? null : value['deletedAt'].toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=BackgroundCheckPackageDto.js.map